<template><!-- svgo-optimised -->
<svg class="icon icon__chevron icon__chevron--right" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg" fill="none"><path d="m9 5 8 7.5L9 20" stroke="currentColor"/></svg>
</template>